import { types as api } from '@mesa-labs/mesa-api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type InvoiceQuarantinesState = {
  partnerId?: api.Partners;
  vendorId?: api.UUID;
  type?: api.InvoiceQuarantineType;
  requiredCorrection?: api.InvoiceQuarantineCorrection;
  status?: api.InvoiceQuarantineStatus;
};

export const initialState: InvoiceQuarantinesState = {
  partnerId: undefined,
  vendorId: undefined,
  type: undefined,
  requiredCorrection: undefined,
  status: api.InvoiceQuarantineStatus.Pending,
};

const invoiceQuarantinesSlice = createSlice({
  name: 'invoiceQuarantines',
  initialState,
  reducers: {
    updatePartnerId(state: InvoiceQuarantinesState, action: PayloadAction<api.Partners | string | undefined>) {
      // query-string sync dispatches strings; keep only real partner ids
      const partnerId = typeof action.payload === 'string' && /^\d+$/.test(action.payload) ? Number(action.payload) : action.payload;
      state.partnerId = typeof partnerId === 'number' && Object.values(api.Partners).includes(partnerId) ? partnerId as api.Partners : undefined;
    },
    updateVendorId(state: InvoiceQuarantinesState, action: PayloadAction<api.UUID | null | undefined>) {
      state.vendorId = action.payload || undefined;
    },
    updateType(state: InvoiceQuarantinesState, action: PayloadAction<api.InvoiceQuarantineType | undefined>) {
      state.type = action.payload;
    },
    updateRequiredCorrection(state: InvoiceQuarantinesState, action: PayloadAction<api.InvoiceQuarantineCorrection | undefined>) {
      state.requiredCorrection = action.payload;
    },
    updateStatus(state: InvoiceQuarantinesState, action: PayloadAction<api.InvoiceQuarantineStatus | undefined>) {
      state.status = action.payload;
    },
  },
});

export const {
  updatePartnerId,
  updateVendorId,
  updateType,
  updateRequiredCorrection,
  updateStatus,
} = invoiceQuarantinesSlice.actions;
export default invoiceQuarantinesSlice.reducer;
